// extracted by mini-css-extract-plugin
export default {"container":"Details_container__j3+yf","title":"Details_title__JN64U","modulesContainer":"Details_modulesContainer__e2yB6","widgetContainer":"Details_widgetContainer__IQB1M"};